// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__pjq3C","card":"Projects_card__k4MZG","link":"Projects_link__w8cbK","cards":"Projects_cards__5H6Xp"};